<template>
  <el-card shadow="always">
    <img class="card-img" v-if="forumObject.istop == 1 && lan == 'ch'" src="../../../assets/icon-recommend.png" alt="">
    <img class="card-img" v-if="forumObject.istop == 1 && lan == 'en'" src="../../../assets/icon-recommend-en.png" alt="">
    <div class="forum_content">
      <div class="forum_content_wrap" style="text-align: justify;">
        <div class="forum_content_wrap_flex" style="width: 45%; float: left;height: 100%;">
          <div class="forum_title">
            <div class="title_header" style="padding-bottom: 20px">{{forumObject.broadcast_name}}</div>
          </div>
          <div class="content_text" style="height: 200px; ">
            <div class="forum_time">
              {{language.time}}: {{forumObject.location}} <br/><br/>
              {{language.compere}}：{{forumObject.truename}}<br/><br/>
              {{language.bbsVisitor}}：{{forumObject.user_post}}</div>
            <!-- <div class="forum_host">{{language.compere}}：{{forumObject.truename}}</div>
            <div class="forum_guest">
              {{language.bbsVisitor}}：{{forumObject.user_post}}
            </div> -->
<!--            <div class="forum_introduce">{{forumObject.broadcast_introduce}}</div>-->
          </div>
          <div class="forum_btn_wrap" style="">
            <div style="float: right;position: relative;top: 25px; ">
                <div class="people_number" style="width: 130px !important; text-align: justify" >
                <img src="../../../assets/form_icon_appointment.png" style="width: 18px;height: 18px;vertical-align: middle;" />
                <!--{{language.present}}  {{forumObject.subscribe_count}}  {{language.people}}  {{language.ahead}}-->
                <span style="margin-left: 5px;display: inline-block;vertical-align: text-bottom;font-size:12px;color:#0b8afd; text-align: justify">
                {{language.alreadyHave}}  {{forumObject.subscribe_count}}  {{language.newAhead}}
              </span>
              </div>


              <div class="logo_right_number">
                <img src="../../../assets/people_number.png" style="width: 18px;height: 18px; vertical-align: middle;" />
                <span style="margin-left: 5px;display: inline-block;vertical-align: text-bottom;font-size:12px;color:#fb9120;">
                {{language.alreadyHave}}
                <span>
                  <!-- style="color: #f4a100;" -->
                  {{forumObject.pnum}}
                  <span v-if="forumObject.pnum > 9999">+</span>
                </span>
                {{language.attend}}
              </span>
              </div>
            </div>
            <el-button
                type="primary"
                @click="handleWatch"
                v-if="
          ExhibitionTypeEnum.END_HAS_ENDED  != exhState
          &&
          forumObject.broadcast_state == 2"
                style="float: right;height: 40px;width:150px;
                position: absolute;
    top: 10px;

                background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none"
            >{{language.watchReplay}}</el-button>
          </div>
        </div>
        <div class="forum_content_wrap_flex" style="">
          <div class="logo" style="float: left;width: 45%;padding-left: 50px;">
              <img
                :src="forumObject.new_broadcast_logo || errorImage"
                style="width:100%;height: 342px;"
              />
          </div>
        </div>
      </div>
<!--      <div class="forum_btn">-->
<!--        <div class="forum_btn_wrap">-->
<!--          <div class="people_number" style="width: 130px !important" >-->
<!--            <img src="../../../assets/form_icon_appointment.png" style="width: 18px;height: 18px;vertical-align: middle;" />-->
<!--            &lt;!&ndash;{{language.present}}  {{forumObject.subscribe_count}}  {{language.people}}  {{language.ahead}}&ndash;&gt;-->
<!--            <span style="margin-left: 5px;display: inline-block;vertical-align: text-bottom;font-size:12px;color:#0b8afd;">-->
<!--              {{language.alreadyHave}}  {{forumObject.subscribe_count}}  {{language.newAhead}}-->
<!--            </span>-->
<!--          </div>-->
<!--          -->

<!--          <div class="logo_right_number">-->
<!--            <img src="../../../assets/people_number.png" style="width: 18px;height: 18px; vertical-align: middle;" />-->
<!--            <span style="margin-left: 5px;display: inline-block;vertical-align: text-bottom;font-size:12px;color:#fb9120;">-->
<!--              {{language.alreadyHave}}-->
<!--              <span>-->
<!--                &lt;!&ndash; style="color: #f4a100;" &ndash;&gt;-->
<!--                {{forumObject.pnum}}-->
<!--                <span v-if="forumObject.pnum > 9999">+</span>-->
<!--              </span>-->
<!--              {{language.attend}}-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->

<!--        &lt;!&ndash; <div style="margin-left: -300px;" v-if="forumObject.broadcast_state != 2 && forumObject.broadcast_state != 0 && forumObject.is_wait != 0 && forumObject.to_wait != 0 && forumObject.wait_num != 0" >-->
<!--          <div class="people_number1" v-if="lan =='en'">{{forumObject.wait_num}} people waiting in line before you. Please wait</div>-->
<!--          <div class="people_number1" v-if="lan =='ch'">您前面有{{forumObject.wait_num}}人排队，请等待。</div>-->
<!--        </div> &ndash;&gt;-->
<!--        <div class="bbs_btn">-->
<!--          &lt;!&ndash;进入  展会状态为开展并且 论坛状态不能为开播又下播&ndash;&gt;-->
<!--          <el-button-->
<!--            type="warning"-->
<!--            style="float: right;height: 40px;width:150px;background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));"-->
<!--            v-if="ExhibitionTypeEnum.ONGOING == exhState && forumObject.broadcast_state == 1"-->
<!--            @click="handleForum"-->
<!--          >{{language.enter}}</el-button>-->
<!--          &lt;!&ndash; <el-button-->
<!--            type="warning"-->
<!--            style="float: right;height: 40px;width:150px;background-color: #f4a100;"-->
<!--            v-if="ExhibitionTypeEnum.ONGOING == exhState && forumObject.broadcast_state != 2 && forumObject.broadcast_state != 0 && (forumObject.is_wait == 0 || (forumObject.is_wait != 0 && forumObject.to_wait == 0))"-->
<!--            @click="handleForum"-->
<!--          >{{language.enter}}</el-button> &ndash;&gt;-->

<!--          &lt;!&ndash; 未开始 &ndash;&gt;-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          style="height: 40px;width: 150px;float: right;margin-right: 27px;background: linear-gradient(0deg, rgb(236, 141, 55), rgb(239, 106, 40));"-->
<!--          v-if="ExhibitionTypeEnum.ONGOING == exhState && forumObject.broadcast_state == 0"-->
<!--          @click="handleForum"-->
<!--        >-->
<!--          {{language.NotStarted}}-->
<!--        </el-button>-->
<!--        &lt;!&ndash; 排队中 &ndash;&gt;-->
<!--        &lt;!&ndash; <el-button-->
<!--          type="warning"-->
<!--          style="height: 40px;width: 150px;float: right"-->
<!--          v-if="ExhibitionTypeEnum.ONGOING == exhState && forumObject.broadcast_state != 2 && (forumObject.is_wait != 0 && forumObject.to_wait != 0)"-->
<!--        >-->
<!--          {{language.InLine}}-->
<!--        </el-button> &ndash;&gt;-->
<!--        -->






<!--          &lt;!&ndash;观看回放  展会状态不能为彻底结束 论坛状态为开播又下播&ndash;&gt;-->
<!--          <el-button-->
<!--            type="primary"-->
<!--            @click="handleWatch"-->
<!--            v-if="-->
<!--          ExhibitionTypeEnum.END_HAS_ENDED  != exhState-->
<!--          &&-->
<!--          forumObject.broadcast_state == 2"-->
<!--            style="float: right;height: 40px;width:150px;background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none"-->
<!--          >{{language.watchReplay}}</el-button>-->
<!--          &lt;!&ndash;预约&ndash;&gt;-->
<!--          <el-button-->
<!--            type="warning"-->
<!--            style="height: 40px;float: right;width:150px;background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none;margin-right: 20px"-->
<!--            v-if="-->
<!--            ExhibitionTypeEnum.HAS_ENDED != exhState-->
<!--            &&-->
<!--            ExhibitionTypeEnum.END_HAS_ENDED != exhState-->
<!--            &&forumObject.subscribe_type != 1-->
<!--          "-->
<!--            @click="handleMake"-->
<!--          >{{language.ahead}}</el-button>-->
<!--          &lt;!&ndash;取消预约&ndash;&gt;-->
<!--          <el-button-->
<!--            type="warning"-->
<!--            style="height: 40px;float: right;width:150px;background: linear-gradient(0deg, rgb(0, 180, 251),  rgb(0, 104, 234));border: none;margin-right: 20px"-->
<!--            v-if="token && forumObject.subscribe_type == 1"-->
<!--            @click="handleUnMake"-->
<!--          >{{language.unfollow}}</el-button>-->
            <!-- <el-button
              type="warning"
              v-if="lan == 'ch' && ExhibitionTypeEnum.ONGOING == exhState"
              style="height: 40px;float: right;width: 150px;background-color: #0f408a;border: none;margin-right: 20px"
              @click="showImg"
            >
            手机海报分享
            </el-button> -->
<!--        </div>-->
<!--      </div>-->
    </div>
  </el-card>
</template>

<script>
import { ExhibitionTypeEnum } from "../../../common/constant/exhibition";
import errorImage from "../../../assets/error_forum.png";
import { stateEnum } from "../oneToOne/enum";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  methods: {
    handleForum() {
      this.$emit("handle-forum", this.forumObject.broadcast_id);
    },
    handleWatch() {
      this.$emit("handleWatch", this.forumObject);
    },
      // 邀请码分享
      showImg() {
        // this.$emit("showImg", this.forumObject)
        this.$emit("showImg1", this.forumObject)
      },
    //预约
    handleMake() {
      this.$emit("handleSubscribe", {
        state: stateEnum.SUBSCRIBE,
        id: this.forumObject.broadcast_id
      });
    },
    //取消预约
    handleUnMake() {
      this.$emit("handleSubscribe", {
        state: stateEnum.CANCELSUB,
        id: this.forumObject.broadcast_id
      });
    }
  },
  props: {
    language: {
      type: Object,
      default: () => {}
    },
    lan: {
      type: String
    },
    forumObject: {
      type: Object,
      default: () => {}
    },
    exhState: {}
  },
  data() {
    return {
      ExhibitionTypeEnum,
      errorImage,
      stateEnum
    };
  }
};
</script>

<style scoped>

.card-img{
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  left: 0;
}
.forum_content {
  padding: 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.forum_content_wrap{
  width: 100%;
  /*display: flex;*/
}
.forum_content_wrap_flex{
  /*flex: 1;*/
}

.logo {

}
.logo_right_number {
  font-size: 14px;
  color: #424242;
}
.content_text {
  /*overflow: hidden;*/
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;  /*要显示的行数*/
  -webkit-box-orient: vertical;
}
.forum_title {
  /* display: flex;
  display: -webkit-flex; */
  justify-content: space-between;
  /*margin: 25px 25px 25px 0;*/
}
.title_header {
  font-family: MicrosoftYaHei-Bold;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  /* line-height: 17px; */
  color: #0f408a;
}
.forum_time {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0;
  color: #424242;
  /* margin-top: 20px; */
  height: auto;
  overflow: hidden;
}
.forum_host {
  margin-top: 25px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0;
  color: #424242;
}
.forum_guest {
  margin-top: 20px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 28px;
  letter-spacing: 0;
  color: #424242;
}
.forum_introduce {
  margin-top: 20px;
  font-family: MicrosoftYaHeiLight;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: #a1a1a1;
  word-wrap: break-word;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /*text-indent: 2em;*/
}
.forum_btn {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.forum_btn_wrap{

  position: absolute;
  height: 50px;
  width: 45%;
  bottom: 45px;
}
.bbs_btn{
  flex: 1;
}
.people_number {
  color: #424242;
  font-size: 14px;
  display: inline-block;
}
.logo_right_number{
  display: inline-block;
}

</style>

